export default "assets/facebook-46cc3926.svg";